import './i18n';

import * as serviceWorker from "./serviceWorker";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import React, { Suspense } from 'react';

import App from './App';
import { CartProvider } from './context/CartContext';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<Suspense fallback={<div>Loading…</div>}>
		<div><Toaster toastOptions={{
			className: 'toaster--c',
			style: {
				background: '#333232',
				color: 'white',
			}
		}} /></div>
		{/* <GlobalProvider> */}
			<BrowserRouter>
				<CartProvider>
					<App />
				</CartProvider>
			</BrowserRouter>
		{/* </GlobalProvider > */}
	</Suspense>
);

serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
